module.exports = __webpack_public_path__ + "img/ic_question_mark_black_filled.bfac7f09.svg";